import { render, staticRenderFns } from "./JiaoHao.vue?vue&type=template&id=3c4bb545&"
import script from "./JiaoHao.vue?vue&type=script&lang=js&"
export * from "./JiaoHao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports